import { reduceAction } from '@elab/core/store/helpers';

import types from './types';

const initialState = {
    towns: [],
    provinces: [],
    province: '',
    town: '',
    loading: false,
};

const reducers = (state = initialState, { type, payload }) => {
    switch (type) {
        case types.SET_PROVINCES:
            return state.provinces.length || payload.length
                ? { ...state, provinces: payload }
                : state;

        case types.SET_TOWNS:
            return state.towns.length || payload.length ? { ...state, towns: payload } : state;

        case types.SET_PROVINCE:
            return reduceAction(state, 'province', payload);

        case types.SET_TOWN:
            return reduceAction(state, 'town', payload);

        case types.RESET_SELECTIONS:
            return {
                ...state,
                town: initialState.town,
                province: initialState.province,
            };
        default:
            return state;
    }
};

export default reducers;
